import angular from 'angular';
import Login from './login/login.module';
import Register from './register/register.module';
import Dashboard from './dashboard/dashboard.module';
import SalesByProducts from './sales-by-products/sales-by-products.module';
import Backups from './backups/backups.module';
import Dtts from './dtts/dtts.module';
import FindInvoice from './find-invoice/find-invoice.module';
import InvoiceNcf from './invoice-ncf/invoice-ncf.module';
import ListArticles from './list-articles/list-articles.module';
import OTH from './oth/oth.module';
import PointOfSales from './point-of-sales/point-of-sales.module';
import SalesReport from './sales-report/sales-report.module';
import PasswordRecovery from './password-recovery/password-recovery.module';
import AccountInformation from './account-information/account-information.module';
import SalesByVendor from './sales-by-vendor/sales-by-vendor.module';
import AccountRegistration from './account-registration/account-registration.module';
import PasswordRequest from './password-request/password-request.module';
import Permissions from './permissions/permissions.module';
import Error404 from './error-404/error-404.module';
import ProfileSelection from './profile-selection/profile-selection.module';
import UserControl from './user-control/user-control.module';
import Collectors from './collectors/collectors.module';
import Collected from './collected/collected.module';
import PendingInvitations from './pending-invitations/pending-invitations.module';
import BillPaymentOnly from './bill-payment-only/bill-payment-only.module';
import PrintedUnclosed from './printed-unclosed/printed-unclosed.module';
import FiscalSalesAnalyser from './fiscal-sales-analyser/fiscal-sales-analyser.module';
import FiscalSalesVisualizer from './fiscal-sales-visualizer/fiscal-sales-visualizer.module';
import FiscalSalesZreport from './fiscal-sales-zreport/fiscal-sales-zreport.module';
import DailyClosing from './daily-closing/daily-closing.module';
import InviteUsers from './invite-users/invite-users.module';
import PrintedBills from './printed-bills/printed-bills.module';
import SalesByCategory from './sales-by-category/sales-by-category.module';
import RequestSuccess from './request-success/request-success.module';
import RecoverySuccess from './recovery-success/recovery-success.module';
import PaymentNotice from './payment-notice/payment-notice.module';
import Handies from './handies/handies.module';
import Subscription from './subscription/subscription.module';
import RawMaterials from './raw-materials/raw-materials.module';
import RawMaterialArticles from './raw-material-articles/raw-material-articles.module';
import SalesBySubfamilyModule from './sales-by-subfamily/sales-by-subfamily.module';
import SalesByFiscalNumberModule from './sales-by-fiscal-number/sales-by-fiscal-number.module';
import SalesDetailsReportModule from './sales-details-report/sales-details-report.module'

const pagesModule = angular.module('app.pagesModule', [
  Login,
  Register,
  AccountRegistration,
  Dashboard,
  SalesByProducts,
  Backups,
  Dtts,
  FindInvoice,
  InvoiceNcf,
  ListArticles,
  OTH,
  PointOfSales,
  SalesReport,
  PasswordRecovery,
  AccountInformation,
  SalesByVendor,
  PasswordRequest,
  Permissions,
  Error404,
  ProfileSelection,
  UserControl,
  Collectors,
  Collected,
  PendingInvitations,
  BillPaymentOnly,
  PrintedUnclosed,
  FiscalSalesAnalyser,
  FiscalSalesVisualizer,
  FiscalSalesZreport,
  DailyClosing,
  InviteUsers,
  PrintedBills,
  SalesByCategory,
  RequestSuccess,
  RecoverySuccess,
  PaymentNotice,
  Handies,
  Subscription,
  RawMaterials,
  RawMaterialArticles,
  SalesBySubfamilyModule,
  SalesByFiscalNumberModule,
  SalesDetailsReportModule
])
.name;

export default pagesModule;



// WEBPACK FOOTER //
// ./src/app/pages/pages.js